module.exports = __webpack_public_path__ + "media/images/logos/logo-elte-497a7c5b4ea5568bcc487241ad7f3573.svg";